export default __webpack_public_path__ + "static/media/tablet_confirmation_balloon.39a261c4.svg";